import ToastDialog from "components/Common/ToastDialog";
import { FieldArray, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { Card,
  Button,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormFeedback,
  Input,
  Label,
  Row,
  Table,
  UncontrolledDropdown,
  UncontrolledTooltip, } from "reactstrap";
import * as Yup from "yup";
import Select from "react-select";
import API_SERVICES from "constants/app.constants";

//Import Breadcrumb
import {
  addAuthorisedPerson,
  deleteAuthorisedPersonList,
  editAuthorisedPerson,
  editAuthorisedPersonStatus,
  getAuthorisedPersonList,
} from "http/fundLync/entityAndAddress.helper";
import { decryptedValue, isPermission } from "common/utility";
import TableContainerV1 from "components/Common/TableContainerV1";
import { formatDateString } from "./borrowingProfile";
import CommonDialog from "components/Common/CommonDialog";


const TableRow = ({ onDelete, onItemSelect, index, validation }) => {
  const currentDate = new Date().toISOString().split("T")[0];
  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];
  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`directorList.${index}.${field}`, value);
  };

  return (
    <div className="mb-3 row">
      <Col sm="12" md="12" className="mb-3 d-flex justify-content-end">
        {validation.values?.directorList?.length > 1 && (
          <i
            className="bx bx-x-circle text-danger"
            onClick={() =>
              onDelete(validation.values.directorList[index], index)
            }
            style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
          />
        )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].firstName`}>First Name </Label>
        <Input
          type="text"
          placeholder="Enter Director First Name"
          name={`[${index}].firstName`}
          id={`[${index}].firstName`}
          value={validation.values.directorList[index].firstName}
          onChange={(e) => handleInputChange(index, "firstName", e.target.value)}
          invalid={
            validation.touched.directorList?.[index]?.firstName &&
            validation.errors.directorList?.[index]?.firstName
          }
        />
        {validation.touched.directorList?.[index]?.firstName &&
          validation.errors.directorList?.[index]?.firstName && (
            <FormFeedback>
              {validation.errors.directorList[index].firstName}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].lastName`}>Last Name </Label>
        <Input
          type="text"
          placeholder="Enter Director Last Name"
          name={`[${index}].lastName`}
          id={`[${index}].lastName`}
          value={validation.values.directorList[index].lastName}
          onChange={(e) => handleInputChange(index, "lastName", e.target.value)}
          invalid={
            validation.touched.directorList?.[index]?.lastName &&
            validation.errors.directorList?.[index]?.lastName
          }
        />
        {validation.touched.directorList?.[index]?.lastName &&
          validation.errors.directorList?.[index]?.lastName && (
            <FormFeedback>
              {validation.errors.directorList[index].lastName}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].email`}>Email </Label>
        <Input
          type="email"
          placeholder="Enter Email"
          name={`[${index}].email`}
          id={`[${index}].email`}
          value={validation.values?.directorList[index]?.email}
          onChange={(e) =>
            handleInputChange(index, "email", e.target.value)
          }
          invalid={
            validation.touched.directorList?.[index]?.email &&
              validation.errors.directorList?.[index]?.email
          }
        />
        {validation.touched.directorList?.[index]?.email &&
          validation.errors.directorList?.[index]?.email && (
            <FormFeedback>
              {validation.errors.directorList[index]?.email}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].mobile`}>Mobile No </Label>
        <Input
          type="text"
          placeholder="Enter Mobile No"
          name={`[${index}].mobile`}
          id={`[${index}].mobile`}
          value={validation.values?.directorList[index]?.mobile}
          onChange={(e) =>
            handleInputChange(index, "mobile", e.target.value)
          }
          invalid={
            validation.touched.directorList?.[index]?.mobile &&
              validation.errors.directorList?.[index]?.mobile
          }
        />
        {validation.touched.directorList?.[index]?.mobile &&
          validation.errors.directorList?.[index]?.mobile && (
            <FormFeedback>
              {validation.errors.directorList[index]?.mobile}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].dob`}>DOB </Label>
        <Input
          type="date"
          placeholder="DD/MM/YYYY"
          name={`director[${index}].dob`}
          id={`director[${index}].dob`}
          max={currentDate}
          value={validation.values.directorList[index].dob}
          onChange={(e) => handleInputChange(index, "dob", e.target.value)}
          invalid={
            validation.touched.directorList?.[index]?.dob &&
            validation.errors.directorList?.[index]?.dob
          }
        />
        {validation.touched.directorList?.[index]?.dob &&
          validation.errors.directorList?.[index]?.dob && (
            <FormFeedback>{"Date of Birth is a required"}</FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].fatherName`}>Father Name </Label>
        <Input
          type="text"
          placeholder="Enter Father's Name"
          name={`director[${index}].fatherName`}
          id={`director[${index}].fatherName`}
          value={validation.values.directorList[index].fatherName}
          onChange={(e) =>
            handleInputChange(index, "fatherName", e.target.value)
          }
          invalid={
            validation.touched.directorList?.[index]?.fatherName &&
            validation.errors.directorList?.[index]?.fatherName
          }
        />
        {validation.touched.directorList?.[index]?.fatherName &&
          validation.errors.directorList?.[index]?.fatherName && (
            <FormFeedback>{"Father Name is Required."}</FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].din`}>DIN </Label>
        <Input
          type="text"
          placeholder="Enter DIN"
          name={`director[${index}].din`}
          id={`director[${index}].din`}
          value={validation.values.directorList[index].din}
          onChange={(e) => handleInputChange(index, "din", e.target.value)}
          invalid={
            validation.touched.directorList?.[index]?.din &&
            validation.errors.directorList?.[index]?.din
          }
        />
        {validation.touched.directorList?.[index]?.din &&
          validation.errors.directorList?.[index]?.din && (
            <FormFeedback>
              {validation.errors.directorList[index].din}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].pan`}>PAN </Label>
        <Input
          type="text"
          placeholder="Enter PAN"
          name={`director[${index}].pan`}
          id={`director[${index}].pan`}
          value={validation.values.directorList[index].pan}
          onChange={(e) =>
            handleInputChange(index, "pan", e.target.value)
          }
          invalid={
            validation.touched.directorList?.[index]?.pan &&
              validation.errors.directorList?.[index]?.pan
          }
        />
        {validation.touched.directorList?.[index]?.pan &&
          validation.errors.directorList?.[index]?.pan && (
            <FormFeedback>
              {validation.errors.directorList[index].pan}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].adharNo`}>Aadhaar No</Label>
        <Input
          type="text"
          placeholder="Enter Adhar No"
          name={`director[${index}].adharNo`}
          id={`director[${index}].adharNo`}
          value={validation.values.directorList[index].adharNo}
          onChange={(e) =>
            handleInputChange(index, "adharNo", e.target.value)
          }
          invalid={
            validation.touched.directorList?.[index]?.adharNo &&
              validation.errors.directorList?.[index]?.adharNo
          }
        />
        {validation.touched.directorList?.[index]?.adharNo &&
          validation.errors.directorList?.[index]?.adharNo && (
            <FormFeedback>
              {validation.errors.directorList[index].adharNo}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].voterId`}>Voter Id</Label>
        <Input
          type="text"
          placeholder="Enter Voter Id"
          name={`director[${index}].voterId`}
          id={`director[${index}].voterId`}
          value={validation.values.directorList[index].voterId}
          onChange={(e) =>
            handleInputChange(index, "voterId", e.target.value)
          }
          invalid={
            validation.touched.directorList?.[index]?.voterId &&
              validation.errors.directorList?.[index]?.pan
          }
        />
        {validation.touched.directorList?.[index]?.voterId &&
          validation.errors.directorList?.[index]?.voterId && (
            <FormFeedback>
              {validation.errors.directorList[index].voterId}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].passportNo`}>Passport No</Label>
        <Input
          type="text"
          placeholder="Enter Passport No"
          name={`director[${index}].passportNo`}
          id={`director[${index}].passportNo`}
          value={validation.values.directorList[index].passportNo}
          onChange={(e) =>
            handleInputChange(index, "passportNo", e.target.value)
          }
          invalid={
            validation.touched.directorList?.[index]?.passportNo &&
              validation.errors.directorList?.[index]?.passportNo
          }
        />
        {validation.touched.directorList?.[index]?.passportNo &&
          validation.errors.directorList?.[index]?.passportNo && (
            <FormFeedback>
              {validation.errors.directorList[index].passportNo}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].rationCardNo`}>Ration Card No</Label>
        <Input
          type="text"
          placeholder="Enter Ration Card No"
          name={`director[${index}].rationCardNo`}
          id={`director[${index}].rationCardNo`}
          value={validation.values.directorList[index].rationCardNo}
          onChange={(e) =>
            handleInputChange(index, "rationCardNo", e.target.value)
          }
          invalid={
            validation.touched.directorList?.[index]?.rationCardNo &&
              validation.errors.directorList?.[index]?.rationCardNo
          }
        />
        {validation.touched.directorList?.[index]?.rationCardNo &&
          validation.errors.directorList?.[index]?.rationCardNo && (
            <FormFeedback>
              {validation.errors.directorList[index].rationCardNo}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].nregaNo`}>NREGA No</Label>
        <Input
          type="text"
          placeholder="Enter NREGA No"
          name={`director[${index}].nregaNo`}
          id={`director[${index}].nregaNo`}
          value={validation.values.directorList[index].nregaNo}
          onChange={(e) =>
            handleInputChange(index, "nregaNo", e.target.value)
          }
          invalid={
            validation.touched.directorList?.[index]?.nregaNo &&
              validation.errors.directorList?.[index]?.nregaNo
          }
        />
        {validation.touched.directorList?.[index]?.nregaNo &&
          validation.errors.directorList?.[index]?.nregaNo && (
            <FormFeedback>
              {validation.errors.directorList[index].nregaNo}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].ckyc`}>CKYC</Label>
        <Input
          type="text"
          placeholder="Enter CKYC"
          name={`director[${index}].ckyc`}
          id={`director[${index}].ckyc`}
          value={validation.values.directorList[index].ckyc}
          onChange={(e) =>
            handleInputChange(index, "ckyc", e.target.value)
          }
          invalid={
            validation.touched.directorList?.[index]?.ckyc &&
              validation.errors.directorList?.[index]?.ckyc
          }
        />
        {validation.touched.directorList?.[index]?.ckyc &&
          validation.errors.directorList?.[index]?.ckyc && (
            <FormFeedback>
              {validation.errors.directorList[index].ckyc}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].drivingLicense`}>Driving License No</Label>
        <Input
          type="text"
          placeholder="Enter Driving License No"
          name={`director[${index}].drivingLicense`}
          id={`director[${index}].drivingLicense`}
          value={validation.values.directorList[index].drivingLicense}
          onChange={(e) =>
            handleInputChange(index, "drivingLicense", e.target.value)
          }
          invalid={
            validation.touched.directorList?.[index]?.drivingLicense &&
              validation.errors.directorList?.[index]?.drivingLicense
          }
        />
        {validation.touched.directorList?.[index]?.drivingLicense &&
          validation.errors.directorList?.[index]?.drivingLicense && (
            <FormFeedback>
              {validation.errors.directorList[index].drivingLicense}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].gender`}>Select Gender</Label>
        <Select
          options={genderOptions}
          placeholder={'Select Gender'}
          className={`select-dropdown ${validation.touched.directorList?.[index]?.gender &&
            validation.errors.directorList?.[index]?.gender
            ? "is-invalid"
            : ""
            }`}
          name={`director[${index}].gender`}
          id={`director[${index}].gender`}
          onChange={(selectedOption) => {
            handleInputChange(index, "gender", selectedOption.value);
          }}
          value={setGender(
            genderOptions,
            validation.values.directorList[index].gender
          )}
        />
        {validation.touched.directorList?.[index]?.gender &&
          validation.errors.directorList?.[index]?.gender && (
            <FormFeedback>
              {validation.errors.directorList?.[index]?.gender}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].dateOfAppointment`}>Date Of Appointment </Label>
        <Input
          type="date"
          placeholder="DD/MM/YYYY"
          name={`director[${index}].dateOfAppointment`}
          id={`director[${index}].dateOfAppointment`}
          max={currentDate}
          value={validation.values.directorList[index].dateOfAppointment}
          onChange={(e) =>
            handleInputChange(index, "dateOfAppointment", e.target.value)
          }
          invalid={
            validation.touched.directorList?.[index]?.dateOfAppointment &&
            validation.errors.directorList?.[index]?.dateOfAppointment
          }
        />
        {validation.touched.directorList?.[index]?.dateOfAppointment &&
          validation.errors.directorList?.[index]?.dateOfAppointment && (
            <FormFeedback>
              {validation.errors.directorList[index].dateOfAppointment}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].designation`}>Designation </Label>
        <Input
          type="text"
          placeholder="Enter Designation"
          name={`director[${index}].designation`}
          id={`director[${index}].designation`}
          value={validation.values.directorList[index].designation}
          onChange={(e) =>
            handleInputChange(index, "designation", e.target.value)
          }
          invalid={
            validation.touched.directorList?.[index]?.designation &&
            validation.errors.directorList?.[index]?.designation
          }
        />
        {validation.touched.directorList?.[index]?.designation &&
          validation.errors.directorList?.[index]?.designation && (
            <FormFeedback>
              {validation.errors.directorList[index].designation}
            </FormFeedback>
          )}
      </Col>
    </div>
  );

  function setGender(data, gender) {
    if (gender) {
      for (const item of data) {
        if (item.value === gender) {
          const value = { label: `${item.label}`, value: gender };
          return value;
        }
      }
    }
  }
};

const Directors = (props) => {
  // document.title = "Directors | FundLync";
  const [rows, setRows] = useState([
    {
      firstName: "",
      lastName: "",
      dob: "",
      fatherName: "",
      din: "",
      dateOfAppointment: "",
      designation: "",
      email: "",
      mobile: "",
      adharNo: "",
      voterId: "",
      passportNo: "",
      rationCardNo: "",
      nregaNo: "",
      ckyc: "",
      drivingLicense: "",
      pan: "",
      gender: ""
    },
  ]);
  const [directorArrayList, setDirectorArrayList] = useState([]);
  const [toastInfo, setToastInfo] = useState({ showToast:false });
  const [isAddDirectorPermission, setAddDirectorPermission] = useState(false);
  const [isEditDirectorPermission, setEditDirectorPermission] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedDirectorIndex, setSelectedDirectorIndex] = useState(null);
  const [selectedDirector, setSelectedDirector] = useState(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [isNewEntityPermission, setIsNewEntityPermission] = useState(false);
  const userObj = decryptedValue(localStorage.getItem("user")) || "{}";
  const { entityType } = userObj || "";
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  });

  const isBase64 = (str) => {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  };

  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);

  const filterType = urlParams.get("filter");
  let decodeFilterType = isBase64(filterType) ? atob(filterType) : filterType;
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  
  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
  },[ entityId, encodedId])
  
  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "First Name",
        accessor: "firstName",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Last Name",
        accessor: "lastName",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Email",
        accessor: "email",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Mobile",
        accessor: "mobile",
        filterable: true,
        Cell: (cellProps) => {
          return `${cellProps.value || ""}`;
        },
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return (
            <TableActionsComponent
              {...rowData}
              setSelectedDirectorIndex={setSelectedDirectorIndex}
              directorArrayList={directorArrayList} // Pass directorArrayList as a prop
              setSelectedDirector={setSelectedDirector}
              toggleEditMode={toggleEditMode}
              deleteDetail={deleteDetail}
            />
          );
        },
      },
    ],
    [directorArrayList]
  );

  // useEffect(() => {
    const getDirectorList = (data, entityId) => {
      const requestData = { ...data, entityId ,type: "director"};
      getAuthorisedPersonList(requestData)
        .then((response) => {
           if(response.status && response.code === 200){
              const allDirectors = response.data.data || [];
              if (allDirectors.length > 0) {
                setDirectorArrayList(allDirectors);
                setRows(allDirectors);
              }
              const { totalItems, totalPages, currentPage } = response.data;
              setPagination({
                pageIndex: currentPage,
                pageCount: totalPages,
                totalRecords: totalItems,
              });
           }
           else{
            setDirectorArrayList([]);
            setPagination({
              pageIndex: 0,
              pageCount: 0,
              totalRecords: 0,
            });
           }
        })
        .catch((error) => {
          console.log(error);
        });

    }
  // }, []);

  const handlePageChange = (
    page,
    pageSize,
    searchKey,
    columnName = columnId,
    sortingOrder = sortingOrderStatus
  ) => {
    setPageSize(pageSize);
    const data = {
      page,
      limit: pageSize,
      searchKey,
      columnName,
      sortingOrder,
    };
    if (filterType) {
      data.filterType = decodeFilterType;
    }
    getDirectorList(data, entityId);
  };

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
  };

  const handleSearchFilter = (value, pageSize) => {
    if (filterType) {
      if (value) {
        setSearchValue(value);
        handlePageChange(1, pageSize, value);
      } else {
        setSearchValue(decodeFilterType);
        handlePageChange(1, pageSize, decodeFilterType);
      }
    } else {
      setSearchValue(value);
      handlePageChange(1, pageSize, value);
    }
  };

  const handleClearSearch = () => {
    if (filterType) {
      setSearchValue(decodeFilterType);
      handlePageChange(1, pageSize, decodeFilterType);
    } else {
      setSearchValue("");
      handlePageChange(1, pageSize, "");
    }
  };

  useEffect(() => {
    if (entityId) {
      if (filterType) {
        getDirectorList({ searchKey: `${decodeFilterType}` }, entityId);
      } else {
        getDirectorList({}, entityId);
      }
    }
  }, [entityId, filterType]);

  useEffect(() => {
    checkPermissions();
  }, []);


  const toggleEditMode = () => {
    setEditMode(!editMode);
  };

 
  const handleBackClick = () => {
    setSelectedDirectorIndex(null);
    setSelectedDirector(null);
  };
  const checkPermissions = async () => {
    const addDirectorpermission = await isPermission(
      "authorised_person",
      "create_permission"
    );
    const editDirectorpermission = await isPermission(
      "authorised_person",
      "edit_permission"
    );

    setAddDirectorPermission(addDirectorpermission);
    setEditDirectorPermission(editDirectorpermission);
  };

  const handleDelete = (rowIndex, index) => {
    if (rowIndex.id) {
      editAuthorisedPersonStatus({ id: rowIndex.id, status: 0 });
    }
    validation.values.directorList.splice(index, 1);
    validation.validateForm();
  };

  const handleItemSelect = (data, value) => {
    data.type = value;
    validation.setFieldValue("type", value);
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      directorList: selectedDirector
        ? [selectedDirector]: [
        {
          firstName: "",
          lastName: "",
          dob: null,
          fatherName: "",
          din: "",
          dateOfAppointment: null,
          designation: "",
          email: "",
          mobile: "",
          adharNo: "",
          voterId: "",
          passportNo: "",
          rationCardNo: "",
          nregaNo: "",
          ckyc: "",
          drivingLicense: "",
          pan: "",
          gender: ""
        },
      ],
    },
    validationSchema: Yup.object({
      directorList: Yup.array().of(
        Yup.object({
          firstName: Yup.string().nullable().notRequired(),
          lastName: Yup.string().nullable().notRequired(),
          fatherName: Yup.string().nullable().notRequired(),
          dob: Yup.date().nullable().notRequired(),
          dateOfAppointment: Yup.date().nullable().notRequired(),
          din: Yup.string().nullable(),
          designation: Yup.string().nullable().notRequired(),
          pan: Yup.string().nullable().matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Enter a valid PAN number"),
          email: Yup.string().nullable().notRequired(),
          gender: Yup.string().nullable().notRequired(),
          mobile: Yup.string().nullable()
            .matches(/^\d{10}$/, "Mobile Number must be exactly 10 digits"),
          adharNo: Yup.string().nullable().matches(/^\d{12}$/, "Aadhar Number must be exactly 12 digits when provided"),
          voterId: Yup.string().nullable(),
          passportNo: Yup.string().nullable(),
          rationCardNo: Yup.string().nullable(),
          nregaNo: Yup.string().nullable(),
          ckyc: Yup.string().nullable(),
          drivingLicense: Yup.string().nullable()
        })
      ),
      
    }),
    onSubmit: (values) => {
      let directorDatas = [...values.directorList];
      for (let value of directorDatas) {
        let dateOfBirth = new Date(value.dob);
        let dateOfAppointment = new Date(value.dateOfAppointment);
        if (dateOfBirth > dateOfAppointment) {
          setToastInfo({
            message: "DOB can't be more than Date of Appointment",
            showToast: true,
            role: "error",
          });
          return;
        }
        value.entityId = +entityId;
        value.type = "director";
        value.status = 1;
        if (!value.dob) {
          value.dob = null;
        }
        if (!value.dateOfAppointment) {
          value.dateOfAppointment = null;
        }
      }
  
      if (!selectedDirector) {
        addAuthorisedPerson({ authorisedPerson: directorDatas })
          .then((response) => {
            setEditMode(false);
            if (response.code === 201 && response.status) {
              setToastInfo({
                message: "Director Added",
                showToast: true,
                role: "success",
              });
              callAfterSave();
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
       editAuthorisedPerson(directorDatas)
          .then((response) => {
            setEditMode(false);
            if (response.code === 201 && response.status) {
              setToastInfo({
                message: "Director Updated",
                showToast: true,
                role: "success",
              });
              callAfterSave();
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  });

  const callAfterSave = () => {
    getAuthorisedPersonList({ entityId, type: "director" })
      .then((response) => {
        const allDirectors = response?.data?.data || [];
        // if (allDirectors.length > 0) {
          setDirectorArrayList(allDirectors);
          setRows(allDirectors);
          setSelectedDirector(null);
          setSelectedDirectorIndex(null)
        // }
        const { totalItems, totalPages, currentPage } = response.data;
              setPagination({
                pageIndex: currentPage,
                pageCount: totalPages,
                totalRecords: totalItems,
              });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //meta 
  const click = ()=>{
    setSelectedDirectorIndex(null)
    setSelectedDirector(null)
  }

  const deleteDetail = (id) => {
    const message = 'Are you sure you want to delete this data?'
    const data = {id}
    setShowCommonDialog({ isShow: true, message, data })
  };
  
  const dialogActionAccept = (action, data) => {
    if (action == 1) {
        setShowCommonDialog({ isShow: false })
        deleteAuthorisedPersonList({id : data.id})
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: "Director Information Deleted Succesfully",
              showToast: true,
              role: "success",
            });
            callAfterSave();
          } else {
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
        setShowCommonDialog({ isShow: false })
    }
  }
  return (
    <React.Fragment>
      <Row>
        <Col sm="12">
          <Card className="p-3">
          
            <div className="text-end mb-3">
              <div style={{cursor: "pointer"}}>
                {editMode ? 
                <div className="text-sm-end">
                    <Button
                      type="button"
                      color="outline-success"
                      className="btn-rounded mb-2 me-2"
                      onClick={() => {
                        setSelectedDirectorIndex(null)
                        setSelectedDirector(null)
                        toggleEditMode(); // This should be a function call
                      }}
                    >
                      close
                    </Button>
                </div>
               : <div className="d-flex justify-content-end">
                  <Button
                    type="button"
                    style={{ backgroundColor: '#21aa47', borderColor: '#21aa47', color: '#fff' }}
                    className="mb-3 me-2"
                    onClick={() => {
                      setEditMode(true);
                      setSelectedDirector(null); 
                      toggleEditMode(); // This should be a function call
                    }}
                  >
                    <i className="fas fa-plus me-2"></i>
                    <span >
                      {" "}
                      Add Director
                    </span>
                  </Button>
                </div>
                }
             </div>
            </div>
            {editMode ? (
              <FormikProvider value={validation}>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <Row className="mb-3">
                    <FieldArray
                      name="directorList"
                      render={(arrayHelpers) => (
                        <>
                          {validation.values.directorList.map((director, index) => (
                            <TableRow
                              key={index}
                              onDelete={handleDelete}
                              onItemSelect={handleItemSelect}
                              index={index}
                              validation={validation}
                            />
                          ))}
                          {selectedDirector === null && ( 
                            <tr>
                              <td colSpan={7}>
                                <span
                                  className="text-success"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    arrayHelpers.push({
                                      firstName: "",
                                      lastName: "",
                                      dob: "",
                                      fatherName: "",
                                      din: "",
                                      dateOfAppointment: "",
                                      designation: "",
                                      email: "",
                                      mobile: "",
                                      adharNo: "",
                                      voterId: "",
                                      passportNo: "",
                                      rationCardNo: "",
                                      nregaNo: "",
                                      ckyc: "",
                                      drivingLicense: "",
                                      pan: "",
                                      gender: ""
                                    });
                                  }}
                                >
                                  <i className="mdi mdi-plus me-1" /> Add Director
                                </span>
                              </td>
                            </tr>
                          )}
                        </>
                      )}
                    />
                  </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      {(directorArrayList.length == 0
                        ? isAddDirectorPermission
                        : isEditDirectorPermission) && (
                          <button type="submit" className="btn btn-success">
                            Save
                          </button>
                        )}
                    </div>
                  </Col>
                </Row>
              </Form>
            </FormikProvider>
            ) : selectedDirectorIndex === null ? (
              
                    <TableContainerV1
                        columns={columns}
                        data={directorArrayList}
                        pagination={pagination}
                        handlePageChange={handlePageChange}
                        handleSearchFilter={handleSearchFilter}
                        sortOptions={sortingOptions}
                        handleSortColumn={handleSortColumn}
                        handleClearSearch={handleClearSearch}
                        className="custom-header-css"
                    />
            ) : (
              <div>
                <div className="mt-3">
                  <Row className="mt-4">
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">First Name</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).firstName || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">Last Name</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).lastName || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">Email</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).email || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">Mobile No.</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).mobile || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">Date of Birth</Label>
                      <span className="mb-0 entityDetailsValue">
                        {formatDateString(directorArrayList.find(d => d.id === selectedDirectorIndex).dob) || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">Father's Name</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).fatherName || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">DIN</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).din || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">PAN</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).pan || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">Aadhaar Number</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).adharNo || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">Voter Id</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).voterId || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">Passport Number</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).passportNo || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">Ration Card Number</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).rationCardNo || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">NREGA No</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).nregaNo || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">CKYC</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).ckyc || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">Driving License Number</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).drivingLicense || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">Gender</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).gender || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">Date of Appointment</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).dateOfAppointment || "-"}
                      </span>
                    </Col>
                    <Col sm="6" md="4" lg="3" className="mb-3 mt-2">
                      <Label className="d-block entityDetails">Designation</Label>
                      <span className="mb-0 entityDetailsValue">
                        {directorArrayList.find(d => d.id === selectedDirectorIndex).designation || "-"}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-end">
                      <Button style={{ backgroundColor: "#21aa47", borderColor: "#21aa47", color: "white" }} onClick={handleBackClick}>
                        Back
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            )}
          </Card>
        </Col>
      </Row>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      {
        showCommonDialog &&
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message} data={showCommonDialog.data}
          postitiveBtn={'Yes'} negativeBtn={'No'} onCloseFn={dialogActionAccept}
        />
      }
    </React.Fragment>
  );
};
const TableActionsComponent = ({ id,directorArrayList,setSelectedDirectorIndex, setSelectedDirector, toggleEditMode, deleteDetail  }) => {
  const handleViewClick = (index) => {
    setSelectedDirectorIndex(index);
  };

  const handleEditClick = (index) => {
    const selectedDirectorData = directorArrayList.find((director) => director.id === id);
    setSelectedDirector(selectedDirectorData);
    toggleEditMode();
  };
  

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem onClick={() => handleViewClick(id)}>
          <i 
            className="mdi mdi-eye font-size-16 text-success me-1"
            id={`viewtooltip_${id}`}
          ></i>
          View
          <UncontrolledTooltip placement="top" target={`viewtooltip_${id}`}>
            View
          </UncontrolledTooltip>
        </DropdownItem>
        <DropdownItem onClick={() => handleEditClick(id)}>
          <i
            className="mdi mdi-pencil font-size-16 text-success me-1"
            id={`edittooltip_${id}`}
          ></i>
          Edit
          <UncontrolledTooltip placement="top" target={`edittooltip_${id}`}>
            Edit
          </UncontrolledTooltip>
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            deleteDetail(id);
          }}
        >
          <i
            className="mdi mdi-delete font-size-16 text-success me-1"
            id="deletetooltip"
          ></i>
          Delete
          <UncontrolledTooltip
            placement="top"
            target="deletetooltip"
          >
            Delete
          </UncontrolledTooltip>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};


export default Directors;
